import { useWatch } from 'react-hook-form';

import { trpc } from '../../config/trpc';

export const useSelectedContact = (name: string) => {
  const watchedId = useWatch({ name });
  const selectedId = watchedId ? Number(watchedId) : null;
  const { data: contact } = trpc.getContact.useQuery({ id: selectedId as number }, { enabled: !!selectedId });

  return { selectedId, contact };
};
